import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

// Import the static template files that live next to this component
const eventsCSVUrl = new URL(
  "./files/eventsCSV.csv",
  import.meta.url
).toString();
const eventsJSONUrl = new URL(
  "./files/eventsJSON.json",
  import.meta.url
).toString();

function ExportTemplate() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleDownload = async (assetUrl, filename) => {
    try {
      const res = await fetch(assetUrl);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Download failed:", e);
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      {/* Trigger button */}
      <MDButton
        color="info"
        startIcon={<DownloadIcon />}
        onClick={() => setOpen(true)}
      >
        {t("common.buttons.template")}
      </MDButton>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          // Style the dialog background and text color
          sx: {
            bgcolor: "#1A2035",
            color: "#fff",
            minWidth: 420,
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          // Header styling
          sx={{
            color: "#fff",
            fontWeight: 700,
            pb: 1,
          }}
        >
          {t("events.create.exportTemplate.title")}
        </DialogTitle>

        <DialogContent
          // Content area styling (white text, subtle separators)
          sx={{
            color: "#fff",
            borderTop: "1px solid rgba(255,255,255,0.08)",
            pt: 2,
          }}
        >
          {/* Row: CSV */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1,
            }}
          >
            <Typography variant="body2" sx={{ color: "#fff" }}>
               {t("events.create.exportTemplate.labelCsv")}
            </Typography>
            <IconButton
              aria-label="download csv template"
              onClick={() =>
                handleDownload(eventsCSVUrl, "events-template.csv")
              }
              sx={{
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.24)",
                borderRadius: 2,
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Box>

          {/* Optional subtle divider */}
          <Box sx={{ borderTop: "1px dashed rgba(255,255,255,0.12)", my: 1 }} />

          {/* Row: JSON */}
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1,
            }}
          >
            <Typography variant="body2" sx={{ color: "#fff" }}>
              JSON
            </Typography>
            <IconButton
              aria-label="download json template"
              onClick={() =>
                handleDownload(eventsJSONUrl, "events-template.json")
              }
              sx={{
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.24)",
                borderRadius: 2,
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Box> */}

          {/* Actions row (right-aligned close) */}
          <Stack direction="row" justifyContent="flex-end" mt={2}>
            <Button
              onClick={() => setOpen(false)}
              sx={{
                color: "#fff",
                textTransform: "none",
                border: "1px solid rgba(255,255,255,0.24)",
                borderRadius: 2,
                px: 2,
              }}
            >
               {t("common.buttons.close")}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ExportTemplate;
